var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 40.2609V3.73913C42 2.77864 41.2214 2 40.2609 2H9.82609L2 9.82609V40.2609C2 41.2214 2.77863 42 3.73913 42H40.2609C41.2214 42 42 41.2214 42 40.2609Z",
    fill: "#F2F0EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47827 22.1734L12.6515 13.5995C12.9865 13.2865 13.5069 13.2872 13.8409 13.6012L24.3478 23.4777M15.6522 32.6082L31.1243 17.1361C31.4639 16.7965 32.0144 16.7965 32.354 17.1361L39.5652 24.3473",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 1.73913V38.2609C39.5 38.9452 38.9452 39.5 38.2609 39.5H1.73913C1.05478 39.5 0.5 38.9452 0.5 38.2609V8.03319L8.03319 0.5H38.2609C38.9452 0.5 39.5 1.05478 39.5 1.73913Z",
    stroke: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 1.73913V38.2609C39.5 38.9452 38.9452 39.5 38.2609 39.5H1.73913C1.05478 39.5 0.5 38.9452 0.5 38.2609V8.03319L8.03319 0.5H38.2609C38.9452 0.5 39.5 1.05478 39.5 1.73913Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 1.73913V38.2609C39.5 38.9452 38.9452 39.5 38.2609 39.5H1.73913C1.05478 39.5 0.5 38.9452 0.5 38.2609V8.03319L8.03319 0.5H38.2609C38.9452 0.5 39.5 1.05478 39.5 1.73913Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 1.73913V38.2609C39.5 38.9452 38.9452 39.5 38.2609 39.5H1.73913C1.05478 39.5 0.5 38.9452 0.5 38.2609V8.03319L8.03319 0.5H38.2609C38.9452 0.5 39.5 1.05478 39.5 1.73913Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8043 9.56462C30.8043 11.6897 29.0816 13.4124 26.9565 13.4124C24.8314 13.4124 23.1086 11.6897 23.1086 9.56462C23.1086 7.43953 24.8314 5.7168 26.9565 5.7168C29.0816 5.7168 30.8043 7.43953 30.8043 9.56462Z",
    stroke: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8043 9.56462C30.8043 11.6897 29.0816 13.4124 26.9565 13.4124C24.8314 13.4124 23.1086 11.6897 23.1086 9.56462C23.1086 7.43953 24.8314 5.7168 26.9565 5.7168C29.0816 5.7168 30.8043 7.43953 30.8043 9.56462Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8043 9.56462C30.8043 11.6897 29.0816 13.4124 26.9565 13.4124C24.8314 13.4124 23.1086 11.6897 23.1086 9.56462C23.1086 7.43953 24.8314 5.7168 26.9565 5.7168C29.0816 5.7168 30.8043 7.43953 30.8043 9.56462Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8043 9.56462C30.8043 11.6897 29.0816 13.4124 26.9565 13.4124C24.8314 13.4124 23.1086 11.6897 23.1086 9.56462C23.1086 7.43953 24.8314 5.7168 26.9565 5.7168C29.0816 5.7168 30.8043 7.43953 30.8043 9.56462Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32603 0.869141C8.32603 0.592998 8.10217 0.369141 7.82603 0.369141C7.54989 0.369141 7.32603 0.592998 7.32603 0.869141H8.32603ZM7.32603 0.869141V6.08653H8.32603V0.869141H7.32603ZM6.0869 7.32566H0.869507V8.32566H6.0869V7.32566ZM7.32603 6.08653C7.32603 6.77088 6.77125 7.32566 6.0869 7.32566V8.32566C7.32354 8.32566 8.32603 7.32317 8.32603 6.08653H7.32603Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.8c1fc4fc4d73cd61f5f9533457c0c89b.svg";
export { ForwardRef as ReactComponent };